import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetchJson = (url: string, options: any = {}): Promise<any> => {
	const option = { ...getDefaultOptions(url), ...options };
	return fetch(url, option).then((response) => {
		if (!response.ok) {
			const { status } = response;
			return response.text().then((str) => {
				throw new FetchError(status, str);
			});
		}

		return response.json();
	});
};

export default fetchJson;
